import React from 'react';
import { Link } from 'react-router-dom';
import atsLogo from '../../assets/img/ATS-logo.png';

const Navbar = ({ onMenuToggle }) => {
    return (
        <div className="header-bottom">
            <div className="container custom-container">
                <div className="row justify-content-between align-items-center">
                    <div className="col-xl-3 col-lg-auto">
                        <div className="header-logo d-flex justify-content-between align-items-center">
                            <Link to="/">
                                <img
                                    src={atsLogo}
                                    alt="Ascend Travel Solutions"
                                    className="logo"
                                    style={{ maxHeight: '100px', width: 'auto' }}
                                />
                            </Link>
                            <div className="d-flex align-items-center gap-3">
                                <button className="wc-link2 searchBoxTggler d-lg-none">
                                    <i className="fas fa-search"></i>
                                </button>

                                <button
                                    className="vs-menu-toggle style2 d-inline-block d-lg-none"
                                    onClick={onMenuToggle}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '24px',
                                        color: '#333',
                                        cursor: 'pointer',
                                        padding: '10px',
                                        display: 'block',
                                        borderRadius: '4px',
                                        transition: 'background-color 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f0f0f0';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <i className="fas fa-bars"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-9 col-lg-auto d-none d-lg-flex justify-content-end gap-md-4 gap-xl-5">
                        <nav className="main-menu menu-style1 v2 d-none d-lg-block">
                            <ul className="d-flex justify-content-center align-items-center gap-4">
                                <li>
                                    <Link 
                                        to="/" 
                                        style={{
                                            textDecoration: 'none',
                                            color: '#333',
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            transition: 'color 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = '#f7bd34ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = '#333';
                                        }}
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/services"
                                        style={{
                                            textDecoration: 'none',
                                            color: '#333',
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            transition: 'color 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = '#f7bd34ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = '#333';
                                        }}
                                    >
                                        Our Services
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/about"
                                        style={{
                                            textDecoration: 'none',
                                            color: '#333',
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            transition: 'color 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = '#f7bd34ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = '#333';
                                        }}
                                    >
                                        About Us
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/enquiry"
                                        style={{
                                            textDecoration: 'none',
                                            color: '#333',
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            transition: 'color 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = '#f7bd34ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = '#333';
                                        }}
                                    >
                                        Enquiry
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/contact"
                                        style={{
                                            textDecoration: 'none',
                                            color: '#333',
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            transition: 'color 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = '#f7bd34ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = '#333';
                                        }}
                                    >
                                        Reach Us
                                    </Link>
                                </li>
                                {/* Optional: Add Admin Login Link */}
                                <li>
                                    <Link 
                                        to="/admin/login"
                                        style={{
                                            textDecoration: 'none',
                                            color: '#f7921f',
                                            fontWeight: '600',
                                            fontSize: '16px',
                                            padding: '8px 16px',
                                            borderRadius: '5px',
                                            border: '2px solid #f7921f',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f7921f';
                                            e.target.style.color = 'white';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = '#f7921f';
                                        }}
                                    >
                                        Admin
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;